import { create } from 'zustand';
import ResponseError from '../../../types/response/ResponseError';
import { PendingUser } from '../../../types/users/PendingUser';
import { ResponseData } from '../../../types/response/ResponseData';

export interface PendingUsersStore {
    isLoading: boolean;
    searchResults: ResponseData<PendingUser[]>;
    searchError?: ResponseError;
    inviteError?: ResponseError;
    deleteError?: ResponseError;
    searchStarted: () => void;
    searchSucceeded: (data: ResponseData<PendingUser[]>) => void;
    searchFailed: (error: ResponseError) => void;
    inviteStarted: () => void;
    inviteFailed: (error: ResponseError) => void;
    deleteStarted: () => void;
    deleteFailed: (error: ResponseError) => void;
    reset: () => void;
}

export const initialState = {
    isLoading: false,
    searchResults: {} as ResponseData<PendingUser[]>,
    searchError: undefined,
    inviteError: undefined,
    deleteError: undefined,
};

export const usePendingUsersStore = create<PendingUsersStore>(set => ({
    ...initialState,

    searchStarted: () =>
        set({
            isLoading: true,
            searchError: undefined,
        }),

    searchSucceeded: (response: ResponseData<PendingUser[]>) =>
        set({
            isLoading: false,
            searchResults: {
                ...response,
                data: response.data.sort(
                    (a, b) => new Date(b.sentAt).getTime() - new Date(a.sentAt).getTime()
                ),
            },
        }),

    searchFailed: (error: ResponseError) =>
        set({
            isLoading: false,
            searchError: error,
        }),

    inviteStarted: () =>
        set({
            isLoading: true,
            inviteError: undefined,
        }),

    inviteFailed: (error: ResponseError) =>
        set({
            isLoading: false,
            inviteError: error,
        }),

    deleteStarted: () =>
        set({
            isLoading: true,
            deleteError: undefined,
        }),

    deleteFailed: (error: ResponseError) =>
        set({
            isLoading: false,
            deleteError: error,
        }),

    reset: () => set(initialState),
}));
